import { OTHER, OTHER_AMOUNT } from "../constants";
import { TipBoxData, TipOption, TipWarnMessage } from "@swiggy-private/cart-types";

export const getTipBoxesData = (selectedAmount: number, tipOptions: TipOption[]): TipBoxData[] => {
    let isOtherAmount = !!selectedAmount;
    const tipBoxesData = tipOptions.map(tipOption => {
        const { amount, mostTipped } = tipOption;
        if (amount === selectedAmount) {
            isOtherAmount = false;
        }
        return {
            selected: amount === selectedAmount,
            boxAmount: amount,
            showMostTippedText: mostTipped && selectedAmount < 1,
            text: amount.toString(),
            showRsIcon: true,
            showCloseIcon: amount === selectedAmount,
        };
    });

    tipBoxesData.push({
        selected: isOtherAmount,
        boxAmount: OTHER_AMOUNT,
        showMostTippedText: false,
        text: OTHER,
        showRsIcon: false,
        showCloseIcon: false,
    });
    return tipBoxesData;
};

export const getTipBoxesDataV4 = (selectedAmount: number, tipOptions: TipOption[]): TipBoxData[] => {
    let isOtherAmount = !!selectedAmount;
    const tipBoxesData = tipOptions.map(tipOption => {
        const { amount, mostTipped } = tipOption;
        if (amount === selectedAmount) {
            isOtherAmount = false;
        }
        return {
            selected: amount === selectedAmount,
            boxAmount: amount,
            showMostTippedText: mostTipped && selectedAmount < 1,
            text: amount.toString(),
            showRsIcon: true,
            showCloseIcon: amount === selectedAmount,
        };
    });

    tipBoxesData.push({
        selected: isOtherAmount,
        boxAmount: OTHER_AMOUNT,
        showMostTippedText: false,
        text: OTHER,
        showRsIcon: false,
        showCloseIcon: isOtherAmount,
    });
    return tipBoxesData;
};

export const isOtherAmount = (selectedAmount: number, tipOptions: TipOption[]): boolean => {
    const found = tipOptions.find(tipOption => {
        return tipOption.amount == selectedAmount;
    });

    return !found && !!selectedAmount;
};

export const getErrorInfo = (
    amount: number,
    tipWarnMessage?: TipWarnMessage,
    minValidTipAmount?: number,
    maxValidTipAmount?: number,
): { title: string; subtitle: string; show: boolean } => {
    let title = null;
    let subtitle = null;
    if (minValidTipAmount && amount < minValidTipAmount) {
        title = tipWarnMessage?.minTipHeadMessage ?? "";
        subtitle = tipWarnMessage?.minTipDescription ?? "";
    } else if (maxValidTipAmount && amount > maxValidTipAmount) {
        title = tipWarnMessage?.maxTipHeadMessage ?? "";
        subtitle = tipWarnMessage?.maxTipDescription ?? "";
    }
    if (title && subtitle) {
        return { title, subtitle, show: true };
    } else {
        return { title: "", subtitle: "", show: false };
    }
};

export const showSeparator = (tipBoxData: TipBoxData[]): boolean => {
    const selected = tipBoxData.some(tipBox => tipBox.selected === true);
    const selectedOther = tipBoxData[tipBoxData.length - 1].selected;
    return selected && !selectedOther;
};

export const isMostTippedTextVisible = (tipBoxData: TipBoxData[]): boolean => {
    return tipBoxData.some(tipBox => tipBox.showMostTippedText === true);
};
